import * as React from 'react';
import { Route } from 'react-router';

import { StatsigProvider } from '@coursera-web/statsig';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import UnifiedUserExperienceHandler from 'bundles/unified-common/providers/UnifiedUserExperienceHandler';
import EnterprisePageWrapper from 'bundles/unified-description-page-common/pages/enterprise/EnterprisePageWrapper';

const EnterpriseCoursePageRoot = loadOnRoute(
  () => import('bundles/unified-description-page-common/pages/enterprise/course/EnterpriseCoursePageRoot')
);
const EnterpriseSpecializationPageRoot = loadOnRoute(
  () =>
    import('bundles/unified-description-page-common/pages/enterprise/specialization/EnterpriseSpecializationPageRoot')
);
const EnterpriseProfessionalCertificatePageRoot = loadOnRoute(
  () =>
    import('bundles/unified-description-page-common/pages/enterprise/professional-certificate/EnterpriseProfessionalCertificatePageRoot')
);
const EnterpriseProjectPageRoot = loadOnRoute(
  () => import('bundles/unified-description-page-common/pages/enterprise/project/EnterpriseProjectPageRoot')
);

const EnterpriseOrgScopedCoursePageRoot = loadOnRoute(
  () => import('bundles/unified-description-page-common/pages/org-scoped/course/EnterpriseOrgScopedCoursePageRoot')
);
const EnterpriseOrgScopedSpecializationPageRoot = loadOnRoute(
  () =>
    import('bundles/unified-description-page-common/pages/org-scoped/specialization/EnterpriseOrgScopedSpecializationPageRoot')
);
const EnterpriseOrgScopedProfessionalCertificatePageRoot = loadOnRoute(
  () =>
    import('bundles/unified-description-page-common/pages/org-scoped/professional-certificate/EnterpriseOrgScopedProfessionalCertificatePageRoot')
);
const EnterpriseOrgScopedProjectPageRoot = loadOnRoute(
  () => import('bundles/unified-description-page-common/pages/org-scoped/project/EnterpriseOrgScopedProjectPageRoot')
);

const EnterprisePageWrapperWithUserExperienceHandler = (props: React.ComponentProps<typeof EnterprisePageWrapper>) => (
  <StatsigProvider>
    <UnifiedUserExperienceHandler>
      <EnterprisePageWrapper {...props} />
    </UnifiedUserExperienceHandler>
  </StatsigProvider>
);

export default (
  <Route>
    <CourseraRoute
      name="enterprise"
      path="/programs/:programSlug"
      component={EnterprisePageWrapperWithUserExperienceHandler}
      handle={{
        tracking: {
          data: (params) => ({
            page: { segment: 'enterprise' },
            enterprise: {
              ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
            },
          }),
        },
      }}
    >
      <CourseraRoute
        name="enterprise-course"
        path="learn/:productSlug"
        getComponent={EnterpriseCoursePageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_course',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-specialization"
        path="specializations/:productSlug"
        getComponent={EnterpriseSpecializationPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_s12n',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-professional-certificate"
        path="professional-certificates/:productSlug"
        getComponent={EnterpriseProfessionalCertificatePageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_professional_cert',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-project"
        path="projects/:productSlug"
        getComponent={EnterpriseProjectPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_project',
              },
            }),
          },
        }}
      />
    </CourseraRoute>
    <CourseraRoute
      name="enterprise-org-scoped"
      path="/organizations/:orgSlug"
      component={EnterprisePageWrapper}
      handle={{
        tracking: {
          data: (params) => ({
            page: { segment: 'enterprise' },
            enterprise: {
              ...(params?.orgSlug ? { organizationSlug: params.orgSlug } : {}),
            },
          }),
        },
      }}
    >
      <CourseraRoute
        name="enterprise-org-scoped-course"
        path="learn/:productSlug"
        getComponent={EnterpriseOrgScopedCoursePageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_course',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-org-scoped-specialization"
        path="specializations/:productSlug"
        getComponent={EnterpriseOrgScopedSpecializationPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_s12n',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-org-scoped-professional-certificate"
        path="professional-certificates/:productSlug"
        getComponent={EnterpriseOrgScopedProfessionalCertificatePageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_professional_cert',
              },
            }),
          },
        }}
      />
      <CourseraRoute
        name="enterprise-org-scoped-project"
        path="projects/:productSlug"
        getComponent={EnterpriseOrgScopedProjectPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_project',
              },
            }),
          },
        }}
      />
    </CourseraRoute>
    <Route path="*" component={NotFound} />
  </Route>
);
